module.exports = {"Born1":{"daobanList":[{"title":"1:是否办理社会保障卡申领","index":0,"state":-1,"values":[{"name":"是","xuanzhong":0,"cailiaoList":[{"name":"有效身份证件（原件）","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{"name":"个人照片","state":"必要"}]}]},{"title":"2、是否本市参保人员","index":1,"state":-1,"values":[{"name":"是","xuanzhong":0,"cailiaoList":[]},{"name":"否","xuanzhong":0,"cailiaoList":[]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx29.json
// module id = 1326
// module chunks = 0